import React, { FC } from 'react';

import { Reservation } from 'api-client';
import { ReactComponent as TooltipAlertIcon } from 'assets/images/svg/tooltip-alert.svg';
import { CustomLink, Money, ProjectStatusBadge, Tooltip } from 'components/common';
import { ProjectDebtClass } from 'components/project';
import { formatDate } from 'formatters';
import { useProjectRowClick } from 'hooks';
import { RouteDictionary } from 'utils';

import { useMyReservationContent } from '../useMyReservationContent';
import styles from './MyReservationMobileCard.module.scss';

interface Props {
  reservation: Reservation;
}

const MyReservationMobileCard: FC<Props> = ({ reservation }) => {
  const { project, accounting, money, roiIrr, hasFunds, action } =
    useMyReservationContent(reservation);
  const handleCardClick = useProjectRowClick(project.uuid);

  return (
    <article className={styles.card} onClick={handleCardClick}>
      <div className={styles.header}>
        <CustomLink
          to={RouteDictionary.DETAILED_PROJECT}
          params={{ uuid: project.uuid }}
          className={styles.projectLink}
        >
          <ProjectDebtClass debtClass={project.context.debt.debtClass} />
          <div className={styles.projectName}>{project.name[0].text}</div>
          {accounting.hasExtraCreditorPayment && (
            <div className={styles.projectMeta}>
              <span className={styles.incasso}>инкассо</span>
            </div>
          )}
        </CustomLink>
        <ProjectStatusBadge status={project.status} />
      </div>

      <div className={styles.metrics}>
        <div className={styles.metric}>
          <span className={styles.metricLabel}>Резервирование</span>
          <span className={styles.metricValue}>
            <Money money={money} compact />
            {!hasFunds && (
              <Tooltip
                content="Средств на балансе недостаточно для оплаты резервирования"
                position="top"
              >
                <TooltipAlertIcon className={styles.infoIcon} />
              </Tooltip>
            )}
          </span>
        </div>
        <div className={styles.metric}>
          <span className={styles.metricLabel}>Прогноз ROI / IRR</span>
          <span className={styles.metricValue}>{roiIrr}</span>
        </div>
        <div className={styles.metric}>
          <span className={styles.metricLabel}>Сбор до</span>
          <span className={styles.metricValue}>{formatDate(accounting.maturityDate)}</span>
        </div>
        <div className={styles.metric}>
          <span className={styles.metricLabel}>План завершения</span>
          <span className={styles.metricValue}>
            {accounting.projectEndDate ? formatDate(accounting.projectEndDate) : '—'}
          </span>
        </div>
      </div>

      <div className={styles.action}>{action}</div>
    </article>
  );
};

export default MyReservationMobileCard;
